import type { UserContext } from '../types/permission.types';

/**
 * Checks whether a context can access a specific module permission.
 *
 * Pure function:
 * - no state
 * - no API
 * - no storage
 * - no framework dependency
 */
export function hasPermission(
  context: UserContext | undefined,
  module: string,
  permission: string
): boolean {
  if (!context) {
    return false;
  }

  const moduleAccess = context.modules.find(
    (item) => item.module === module
  );

  if (!moduleAccess) {
    return false;
  }

  if (!moduleAccess.enabled) {
    return false;
  }

  return moduleAccess.permissions.includes(permission);
}
